/** Where a person lands when Flow is not switched on for them: the explanation, not a silent redirect to Home. */
export const FLOW_OFF_ROUTE = '/flow-off';
